import React from "react"
import MultiDevise from "./MultiDevise"

const MAX_NODES = 10000
const isObject = value => value !== null && typeof value === "object" && !Array.isArray(value)

function parse(value, empty) {
    return value == null || value === "" ? empty : typeof value === "string" ? JSON.parse(value) : value
}

function contentMayAcceptDonation(value) {
    const content = parse(value, {rows:[]})
    if (!isObject(content) || !Array.isArray(content.rows) || content.rows.length > MAX_NODES) return true
    const pending = [...content.rows]
    const visited = new Set()
    let count = 0
    while (pending.length) {
        const row = pending.pop()
        if (!isObject(row) || !Array.isArray(row.cells) || visited.has(row)) return true
        visited.add(row)
        if (++count > MAX_NODES) return true
        for (const cell of row.cells) {
            if (!isObject(cell) || ++count > MAX_NODES) return true
            if (cell.plugin != null && !isObject(cell.plugin)) return true
            const id = cell.plugin?.id
            if (id != null && typeof id !== "string") return true
            // Referenced blocks aren't in this definition: keep access when unsure.
            if (id === "form-free-amount" || id?.startsWith("form-free-amount/")
                || id === "form-block" || id?.startsWith("form-block/")) return true
            if (cell.rows != null) {
                if (!Array.isArray(cell.rows) || pending.length + cell.rows.length > MAX_NODES) return true
                for (const child of cell.rows) pending.push(child)
            }
        }
    }
    return false
}

function modulesMayAcceptDonation(value) {
    const modules = parse(value, [])
    if (!Array.isArray(modules) || modules.length > MAX_NODES) return true
    for (const module of modules) {
        if (!isObject(module) || module.type === "BLOCK-FORM" || module.type === "FREE-AMOUNT-INPUT") return true
    }
    return false
}

function amountMayBePaid(value) {
    if (value == null || value === "") return false
    if (typeof value !== "number" && typeof value !== "string") return true
    const amount = Number(value)
    return !Number.isFinite(amount) || amount !== 0
}

// Use only the form already supplied to this page. Never the cart, a temporary
// discount or an additional request. Unreadable data preserves currency access.
export function formNeedsCurrencyChoice(form) {
    try {
        if (!isObject(form)) return true
        // Legacy editor donations can still be collected with payment disabled.
        if (contentMayAcceptDonation(form.content)) return true
        if (form.simpleEditor && form.withPaiement && modulesMayAcceptDonation(form.modulesContent)) return true
        if (!form.withPaiement) return false
        if (!Array.isArray(form.products) || form.products.length > MAX_NODES) return true
        for (const product of form.products) {
            if (!isObject(product)) return true
            if (product.active === false) continue
            if (amountMayBePaid(product.montant)) return true
            if (form.simpleEditor && modulesMayAcceptDonation(product.modulesContent)) return true
            if (Object.keys(product).some(key => /^[a-z]{3}$/i.test(key)
                && isObject(product[key]) && amountMayBePaid(product[key].montant))) return true
        }
        return false
    } catch (_) {
        return true
    }
}

export default function FormMultiDevise({context, form}) {
    if (!context?.org || !form || !formNeedsCurrencyChoice(form)) return null
    return <>
        <MultiDevise context={context} object={form} mode="modal" />
        <MultiDevise context={context} object={form} />
    </>
}
